<template>
  <div class="wb-elements-item-card-uploading">
    <div>
      <span>{{ text }}</span>
      <el-progress
        :percentage="percentage"
        :format="formatPercentage"
        :stroke-width="6"
        :color="'#4780FF'"
      ></el-progress>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ElementsItemCardUploading',
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: '上传中'
    }
  },
  methods: {
    formatPercentage() {
      return '';
    }
  }
};
</script>
<style lang="scss">
.wb-elements-item-card-uploading {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9;
  > div {
    width: 100%;
    > span {
      display: inline-block;
      margin-top: 10px;
      color: #fff;
    }
  }
  .el-progress-bar {
    .el-progress-bar__outer {
      background: rgba(199, 208, 242, 0.3);
    }
  }
}
</style>
